import { useContext } from "react"

import SessionContext, {
  OrganizationType,
  OrgMemberType,
} from "@providers/SessionProvider/SessionContext"

import { DigitPermission, User } from "@gql/graphql"

export interface SessionData {
  currentUser: User | null | undefined
  hasPermission: (permission: DigitPermission) => boolean
  org: OrganizationType | null | undefined
  orgMember: OrgMemberType | null | undefined
  refetchSession: () => void
}

const useSession = (): SessionData => {
  const { currentUser, currentPermissions, org, orgMember, refetchSession } =
    useContext(SessionContext)

  return {
    currentUser,
    hasPermission: (permission: DigitPermission) =>
      currentPermissions?.has(permission) ?? false,
    org,
    orgMember,
    refetchSession,
  }
}

export default useSession
